"use client"

import Image from "next/image"
import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Linkedin } from "lucide-react"

const team = [
  {
    name: "Gentian Elmazi",
    title: "Co-Founder & CEO",
    bio: "Over a decade of experience in software engineering and more than seven years building and scaling technology companies.",
    image: "/1_genti.webp",
    linkedin: "https://www.linkedin.com/in/gentianelmazi/",
  },
  {
    name: "Agon Fejza",
    title: "Co-Founder",
    bio: "Co-developed internal processes and tools to enhance engineering efficiency, driving measurable improvements in quality, velocity, and collaboration.",
    image: "/1_agon.webp",
    linkedin: "https://www.linkedin.com/in/agonfejza/",
  },
]

export function TeamSection() {
  return (
    <section className="px-6 py-24">
      <div className="mx-auto max-w-4xl">
        <div className="mb-16 text-center">
          <span className="mb-4 inline-block text-sm font-semibold uppercase tracking-widest text-primary">
            Leadership
          </span>
          <h2 className="text-balance text-3xl font-bold text-foreground md:text-5xl">
            Meet the <span className="text-primary">Team</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-pretty text-lg leading-relaxed text-muted-foreground">
            The people behind Infinitcode AI.
          </p>
        </div>

        <div className="mx-auto grid max-w-2xl gap-6 sm:grid-cols-2">
          {team.map((member) => (
            <Card
              key={member.name}
              className="group border-border/50 bg-card/50 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5"
            >
              <CardContent className="flex flex-col items-center pt-6 text-center">
                {/* Photo */}
                <div className="mb-4 w-40 h-44 overflow-hidden rounded-2xl border border-border/50 transition-all duration-300 group-hover:border-primary/30 group-hover:shadow-md group-hover:shadow-primary/10">
                  <Image
                    src={member.image}
                    alt={`${member.name}, ${member.title}`}
                    width={160}
                    height={160}
                    className="size-full object-cover object-top"
                  />
                </div>

                {/* Info */}
                <h3 className="text-lg font-semibold text-foreground">
                  {member.name}
                </h3>
                <p className="mb-3 text-sm font-medium text-primary">
                  {member.title}
                </p>
                <p className="mb-4 text-sm leading-relaxed text-muted-foreground">
                  {member.bio}
                </p>

                {/* LinkedIn */}
                <Button
                  variant="outline"
                  size="icon-sm"
                  className="mt-auto border-border/50 text-muted-foreground hover:border-primary/50 hover:text-primary hover:bg-primary/10"
                  asChild
                >
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${member.name} on LinkedIn`}
                  >
                    <Linkedin className="size-4" />
                  </a>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
